export const THREAD_REOPEN_SPLIT_MESSAGE = 'THREAD_REOPEN_SPLIT_MESSAGE';